import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { OperatorAuthService } from './operator-auth.service';

export const operatorAuthGuard: CanActivateFn = () => {
  const auth = inject(OperatorAuthService);
  const router = inject(Router);

  return auth.ensureAuthenticated().pipe(map((isAuthenticated) => (isAuthenticated ? true : router.createUrlTree(['/login']))));
};
